import apiAthleteResults from '@/api/athlete-result'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  editAthleteResultStart: '[edit athlete result] Edit athlete result start',
  editAthleteResultSuccess: '[edit athlete result] Edit athlete result success',
  editAthleteResultFailure: '[edit athlete result] Edit athlete result failure'
}

export const actionTypes = {
  editAthleteResult: '[edit athlete result] Edit athlete result'
}

const mutations = {
  [mutationTypes.editAthleteResultStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.editAthleteResultSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.editAthleteResultFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.editAthleteResult](context, {id, athleteResultInput}) {
    context.commit(mutationTypes.editAthleteResultStart)
    return new Promise(resolve => {
      apiAthleteResults
        .updateAthleteResult(id, athleteResultInput)
        .then(response => {
          context.commit(mutationTypes.editAthleteResultSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.editAthleteResultFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
